import { AppButton, PageContainer } from '@/components';
import { useCartStore } from '@/store';
import CartListItems from './CartListItems';
import useBasketManagement from '@/hooks/app/useBasketManagement';
import { useTranslation } from 'react-i18next';
import { envConfig } from '@/configs';

export default function Cart() {
  const [t] = useTranslation();
  const basketItems = useCartStore(state => state.programs);
  const { loading, error, submit } = useBasketManagement();

  const getSumOfPrices = () => {
    let sum = 0;
    basketItems.forEach(x => {
      sum += (x.food!.price * x.selectedCount) || 0;
    });
    return (sum / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return (
    <PageContainer
      title={t('common:labels.cart')}
      displayFlex
    >
      <CartListItems />
      {basketItems.length > 0 && (
        <div className="mb-8 flex flex-col items-center justify-center gap-4">
          <span className="mt-4 text-center font-bold font-l text-nurture-darker">
            {`${t('common:labels.total-amount')}: ${getSumOfPrices()} ${envConfig.ui.removeCurrency ? '' : t('common:labels.tomans')}`}
          </span>
          {error !== '' && (
            <p className="text-center text-[#C7090C]">{error}</p>
          )}
          <AppButton
            size="large"
            appVariant="submit"
            loading={loading}
            disabled={loading}
            onClick={submit}
            className="mx-auto h-auto min-h-12 w-full max-w-md py-3 !text-lg"
          >
            {t('common:labels.submit-pay')}
          </AppButton>
        </div>
      )}
    </PageContainer>
  );
}
